export default __webpack_public_path__ + "static/mstile-150x150.png";